export const LeagueImages = {
    'NBA': 'NBA.png',
    'NFL': 'NFL.png',
    'NHL': 'NHL.png',
    'COLLEGE-BASKETBALL': 'COLLEGE-BASKETBALL.png',
    'COLLEGE-FOOTBALL': 'COLLEGE-FOOTBALL.png',
    'MLB': 'MLB.png',
}

export const FriendlyLeagueNames = {
    'nfl': 'NFL',
    'nba': 'NBA',
    'college-basketball': 'College Basketball',
    'college-football': 'College Football',
    'nhl': 'NHL',
    'mlb': 'MLB',
}

export const SportsBookImages = {
    Bet365NewJersey: 'Wide/logo_wide_bet365@2x.png',
    Bet365: 'Wide/logo_wide_bet365@2x.png',
    CaesarsNewJersey: 'Wide/logo_wide_caesars@2x.png',
    CaesarsPennsylvania: 'Wide/logo_wide_caesars@2x.png',
    DraftKings: 'Wide/logo_wide_draftkings@2x.png',
    FanDuel: 'Wide/logo_wide_fanduel@2x.png',
    LadBrokes: 'ladbrokes.png',
    MGM: 'Wide/logo_wide_betmgm@2x.png',
    PointsBet: 'Wide/logo_wide_pointsbet@2x.png',
    SugarHouseNJ: 'Wide/sugarhouse-widest.png',
    BetRivers: 'Wide/logo_wide_betrivers@2x.png',
    Unibet: 'Wide/unibet-widest.png',
    PlanetPinnacle: 'pinnacle.png',
    HardRock: 'Wide/logo_wide_hardrock@2x.png',
    EightEightEight: 'Wide/logo_wide_888@2x.png',
    FoxBet: 'Wide/logo_wide_foxbet@2x.png',
    BetAmerica: 'Wide/logo_wide_betamerica@2x.png',
    Caesars: 'Wide/logo_wide_caesars@2x.png',
    Westgate: 'westGate.png',
    WilliamHill: 'Wide/logo_wide_williamhill@2x.png',
    WilliamHillNewJersey: 'Wide/logo_wide_williamhill@2x.png',
    Wynn: 'wynn.jpg'
}

export const SportsBookLogos = {
    Bet365NewJersey: 'Symbols_Square/logo_square_bet365@2x.png',
    Bet365: 'Symbols_Square/logo_square_bet365@2x.png',
    CaesarsNewJersey: 'Symbols_Square/logo_square_caesars@2x.png',
    CaesarsPennsylvania: 'Symbols_Square/logo_square_caesars@2x.png',
    DraftKings: 'Symbols_Square/logo_square_draftkings@2x.png',
    FanDuel: 'Symbols_Square/logo_square_fanduel@2x.png',
    LadBrokes: 'ladbrokes.png',
    MGM: 'Symbols_Square/logo_square_betmgm@2x.png',
    PointsBet: 'Symbols_Square/logo_square_pointsbet@2x.png',
    SugarHouseNJ: 'Symbols_Square/logo_square_sugarhouse@2x.png',
    BetRivers: 'Symbols_Square/logo_square_betrivers@2x.png',
    Unibet: 'Symbols_Square/logo_square_unibet@2x.png',
    PlanetPinnacle: 'pinnacle.png',
    HardRock: 'Symbols_Square/logo_square_hardrock@2x.png',
    EightEightEight: 'Symbols_Square/logo_square_888@2x.png',
    FoxBet: 'Symbols_Square/logo_square_foxbet@2x.png',
    BetAmerica: 'Symbols_Square/logo_square_betamerica@2x.png',
    Caesars: 'Symbols_Square/logo_square_caesars@2x.png',
    Westgate: 'westGate.png',
    WilliamHill: 'Symbols_Square/logo_square_williamhill@2x.png',
    WilliamHillNewJersey: 'Symbols_Square/logo_square_williamhill@2x.png',
    Wynn: 'wynn.jpg'
}

export const SportsBookLinks = {
    Bet365NewJersey: 'https://www.nj.bet365.com/',
    Bet365: 'https://www.bet365.com/',
    CaesarsNewJersey: 'https://www.caesarscasino.com/sports/',
    CaesarsPennsylvania: 'https://www.caesarscasino.com/sports/',
    DraftKings: 'https://sportsbook.draftkings.com/sportsbook',
    FanDuel: 'https://sportsbook.fanduel.com/',
    LadBrokes: 'https://www.ladbrokes.com/',
    MGM: 'https://promo.nj.betmgm.com/en/promo/geolocator?orh=sports.betmgm.com',
    PointsBet: 'https://pointsbet.com/',
    SugarHouseNJ: 'https://www.playsugarhouse.com/',
    BetRivers: 'https://www.betrivers.com/',
    Unibet: 'https://www.unibet.com/',
    PlanetPinnacle: 'https://www.pinnacle.com/en/',
    HardRock: 'https://www.hardrockcasino.com/sportsbook',
    EightEightEight: 'https://us.888sport.com/',
    FoxBet: 'https://www.foxbet.com/?no_redirect=1',
    BetAmerica: 'https://www.betamerica.com/',
    Caesars: 'https://www.caesarscasino.com/sports/',
    Westgate: 'https://www.westgateresorts.com/hotels/nevada/las-vegas/westgate-las-vegas-resort-casino/casino/race-sports-book/',
    WilliamHill: 'https://www.williamhill.com/us',
    WilliamHillNewJersey: 'https://www.williamhill.com/us/nj/',
    Wynn: 'https://www.wynnlasvegas.com/casino/race-sports-book'
}

export const FuturesSlugsShort = {
    'nfl-afc-conference-winner': 'AFC Conference',
    'nfl-afc-division-east-winner-reg-season': 'AFC East',
    'nfl-afc-division-north-winner-reg-season': 'AFC North',
    'nfl-afc-division-south-winner-reg-season': 'AFC South',
    'nfl-afc-division-west-winner-reg-season': 'AFC West',
    'nfl-awards-most-valuable-player-reg-season': 'Awards Most',
    'nfl-draft-1st-drafted-offensive-lineman': 'Draft Offensive',
    'nfl-draft-1st-drafted-quarterback': 'Draft Quarterback',
    'nfl-draft-1st-drafted-running-back': 'Draft Running Back',
    'nfl-draft-1st-drafted-wide-receiver': 'Draft Wide Receiver',
    'nfl-draft-1st-overall-pick': 'Draft Overall Pick',
    'nfl-draft-2nd-overall-pick': 'Draft Overall Pick 2',
    'nfl-nfc-conference-winner': 'NFC Conference',
    'nfl-nfc-division-east-winner-reg-season': 'NFC East',
    'nfl-nfc-division-north-winner-reg-season': 'NFC North',
    'nfl-nfc-division-south-winner-reg-season': 'NFC South',
    'nfl-nfc-division-west-winner-reg-season': 'NFC West',
    'nfl-super-bowl-56-winner': 'Super Bowl',
}

export const MarketName = {
    '2way': 'Moneylines',
    'total': 'Totals',
    'puck_line': 'Puck lines',
    'run_line': 'Run lines',
    'spread': 'Spreads',
};

export const getFriendlyTeamName = (league, competitor, isTitle) => {
    const market = competitor['market'];
    const name = competitor['name'];
    if (isTitle) {
        return market + ' ' + name;
    }
    if (league === 'college-basketball' || league === 'college-football') {
        if (market === 'Massachusetts-Lowell') {
            return "UMass Lowell";
        } else if (market === 'Virginia Commonwealth') {
            return 'VCU';
        }
        return market;
    } else {
        if (league === 'nfl' && market === 'Washington') {
            return market;
        }
        if (league === 'nba' && name === 'Timberwolves') {
            return "T-wolves";
        }
        return name;
    }
}

export const getTeamEventUrl = (league, game) => {
    const {slugs} = game;
    const {away_slug, home_slug, scheduled_slug} = slugs;

    let url = `/${league}/${away_slug}-vs-${home_slug}-odds-${scheduled_slug}/`;

    return url.toLowerCase();
}

export const getLineHistoryUrl = (league, game) => {
    const {slugs} = game;
    const {away_slug, home_slug, scheduled_slug} = slugs;

    let url = `/${league}/${away_slug}-vs-${home_slug}-line-history-${scheduled_slug}/`;

    return url.toLowerCase();
}

export const getTeamImage = (league, competitor) => {
    league = league.toUpperCase();
    const ext = league === 'NFL' ? '.svg' : '.png';
    if (!competitor['alias'] && !competitor['abbreviation']) {
        console.warn(`Could not find image for team: ${competitor}`);
        return null;
    }
    const alias = competitor['alias'] || competitor['abbreviation'];
    return `${process.env.PUBLIC_URL}/images/logos/${league}/${alias.toUpperCase()}${ext}`;
}

export const numberToFraction = (num, type, isHome) => {
    if (type === 'spread' && !isHome) {
        num = -num;
    }
    if (num > 0) {
        num = '+' + num;
    }

    const tokens = num.toString().split('.');

    if (tokens.length === 2) {
        return tokens[0] + "½";
    }

    return num;
}

